export const Settings = {
  REEL_COUNT: 5,
  SYMBOLS_VISIBLE: 3,
  SYMBOL_WIDTH: 210, // Maximum symbol width
  SYMBOL_HEIGHT: 252, // Maximum symbol height (aspect ratio from 221x266 original)
  // Per-category scale multipliers. Keys match symbolData.symbolPay values.
  // Unlisted categories fall back to DEFAULT. Feature symbols render at 1.0 (natural size).
  // Old system had SYMBOL_PADDING (0.025) + per-category overrides — now baked into one value.
  SYMBOL_SCALE_OVERRIDES: {
    DEFAULT: 0.95,   // Global shrink (was padding 0.025 → 1 - 0.05 = 0.95)
    mp: 0.9975,      // Mid pay (m1-m4): 0.95 × 1.05
    lp: 0.9025,      // Low pay (l1-l5): 0.95 × 0.95
    wild: 0.95,      // Wild: 0.95 × 1.0
    feature: 1.0,    // Zeus orbs: no shrink (natural size)
  },
  COIN_VALUE_FONT_SIZE_MULTIPLIER: 0.25, // Font size for coin values as fraction of symbol height

  APP: {
    RGS_PROVIDER: "PopiPlay",
    GAME_NAME: "3 Orbs of Zeus",
    UI_THEME: "secondary",
  },
};

// Game layout configurationan - pre-generated arrays for reel and symbol indices
export const GAME_LAYOUT = {
  REEL_COUNT: Settings.REEL_COUNT,
  SYMBOLS_VISIBLE: Settings.SYMBOLS_VISIBLE,
  SYMBOL_INDICES: Array.from(
    { length: Settings.SYMBOLS_VISIBLE },
    (_, idx) => idx,
  ),
  REEL_INDICES: Array.from({ length: Settings.REEL_COUNT }, (_, idx) => idx),
  MIDDLE_REEL: Math.floor((Settings.REEL_COUNT - 1) / 2), // Middle reel index (for 5 reels = 2)
  SECOND_REEL: Math.floor((Settings.REEL_COUNT - 1) / 2) - 1, // Second reel index (for 5 reels = 1)
};

export const APP_VERSION = "27.04.2026 - 14:25";

// Stage dimensions - centralized configuration
export const STAGE_DIMENSIONS = {
  MAX_WIDTH: 3840, // Maximum stage width for UI constraint and background scaling
  MAX_HEIGHT: 3200, // Maximum background height (for reference)
};
